import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "nav-item nav-entry nav-entry__account d-none d-xl-block"
};
const _hoisted_2 = { class: "dropdown" };
const _hoisted_3 = { class: "caption" };
const _hoisted_4 = { class: "text-muted" };
const _hoisted_5 = { class: "text" };
const _hoisted_6 = { class: "icon-container" };
const _hoisted_7 = ["title"];
const _hoisted_8 = { class: "content" };
const _hoisted_9 = ["data-is-open"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_ecommerce__account_select = _resolveComponent("g-ecommerce__account-select");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_ctx.accountDisplayName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                    class: "d-flex dropdown-toggle",
                    style: { "cursor": "pointer" },
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.toogleButton_Account && _ctx.toogleButton_Account(...args)))
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$tc('client.Identity.Accounts.Current')), 1),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.accountDisplayName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                            class: "icon",
                            title: _ctx.$tc('client.Identity.Accounts.Current')
                        }, [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/building.svg",
                                    style: { "margin-bottom": "2px" }
                                })
                            ])
                        ], 8, _hoisted_7)
                    ])
                ]),
                (_ctx.isOpen)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["dropdown-menu p-0 mt-1", { show: _ctx.isOpen }]),
                        style: { "width": "400px", "right": "0" },
                        "aria-labelledby": "cmdMainAccount",
                        "data-is-open": _ctx.isOpen
                    }, [
                        _createVNode(_component_g_ecommerce__account_select, { onClose: _ctx.closeDropdown }, null, 8, ["onClose"])
                    ], 10, _hoisted_9)), [
                        [_directive_click_outside, _ctx.closeDropdown]
                    ])
                    : _createCommentVNode("", true)
            ])
        ]))
        : _createCommentVNode("", true);
}
